import styled from 'styled-components';
import PopoverTabButton from '../popoverTabs/PopoverTabButton';
import { mainTheme } from '@plecto/ui';

export const PopoverTabButtonToggle = styled(PopoverTabButton)`
	width: 100%;
	display: inline-block;
	.popover-tab-button {
		padding: 4px 10px 4px 12px;
		border: 1px solid ${mainTheme.form.dropdown.box.border};
		border-radius: 4px;
		background-color: ${mainTheme.form.dropdown.box.background};
		color: ${mainTheme.form.dropdown.box.color};
		width: 100%;
		text-align: left;

		// The toggle carries .btn-default, so the app's bootstrap paints its hover,
		// focus and active states light unless every one of them is claimed here.
		&:hover,
		&:focus,
		&:active,
		&.popover-tab-button-open {
			background-color: ${mainTheme.form.dropdown.box.background};
			color: ${mainTheme.form.dropdown.box.color};
			border-color: ${mainTheme.form.dropdown.box.open.border};
		}
		.multi-level-dropdown-toggle-icon {
			float: right;
		}
	}

	button.popover-tab-button-open {
		border-bottom-left-radius: 0;
		border-bottom-right-radius: 0;
	}
	button.popover-tab-top-start {
		border-top-left-radius: 0;
		border-top-right-radius: 0;
	}
`;
